import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Layout, Typography, Card, Button } from 'antd';
import { FileOutlined } from '@ant-design/icons';
import date from '../../../helpers/date';
import TramittaLogo from '../../../images/tramitta-logo.png';
import LegalChileLogo from '../../../images/legalchile.svg';
import { SEND_MAIL } from '../../../state/mail/types';
import { SEND_MONITORING } from '../../../state/dashboard/types';
import Success from '../../paymentFeedback/CreationSuccess';
import Fail from '../../paymentFeedback/CreationFail';
import YapoLogo from '../../../images/yapo_logo.png';
import { EXTERNAL_URL } from '../../../config/constants/urls';
import PropTypes from 'prop-types';

const { Header, Content } = Layout;
const { Title, Text } = Typography;
const { formatString } = date;

const WebpayConfirmation = ({
  data,
  sendMail,
  sendStats,
  sourceUrl
}) => {

  const [activeView, setActiveView] = useState(null);
  const installments_number = ((data.installments_number && data.installments_number > 0) ? data.installments_number : 'Sin cuotas');
  const installments_amount = (data.installments_amount ? `$${data.installments_amount}` : 'Sin cuotas');

  useEffect(() => {
    setActiveView(0);
    const email = sessionStorage.getItem('ownerMail');
    if (email !== null) {
      const paymentData = {
        docID: data.buy_order,
        payment: {
          state: data.status,
          paymentMethod: data.payment_type_code,
          total: data.amount,
          currency: 'CLP',
          transactionDate: data.transaction_date,
          cardNumber: parseInt(data.card_detail.card_number),
          authCode: data.authorization_code,
        }
      };
      sendMail(email, paymentData);
      sendStats('success');
      sessionStorage.removeItem('ownerMail');
    }
  }, []);

  const redirectTo = () => {
    if (data.savePayment) {
      setActiveView(1);
    } else {
      setActiveView(2);
    }
  };

  const PurcharseDetail = () => (
    <React.Fragment key="transaction-success">
      <Header className="header-container">
        <Row className="header-logos mb-0">
          <img src={LegalChileLogo} alt="" className="legal-logo" />
          {sourceUrl === EXTERNAL_URL.YAPO &&
            <img src={YapoLogo} alt="" className="yapo-logo" />
          }
          <img src={TramittaLogo} alt="" className="tramitta-logo" />
        </Row>
      </Header>
      <Content className="ant-layout-content-custom">
        <Row className="mb-4">
          <Col md={12} className="text-center mx-auto">
            <FileOutlined style={{ fontSize: '40px', color: '#00F' }} className="mb-4" />
            <Title level={1}>Detalle de la compra</Title>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={18} lg={12} xl={10} className="mx-auto position-relative">
            <Card className="mx-auto text-center mb-4">
              <Title level={4} className="mb-4">Contrato de arriendo</Title>
              <ul style={{ padding: 0 }}>
                <li className="d-flex justify-content-between mb-2">
                  <span className="fs-xs">Nombre de comercio:</span>
                  <Text strong>LegalChile</Text>
                </li>
                <li className="d-flex justify-content-between mb-2">
                  <span className="fs-xs">Producto:</span>
                  <Text strong>Contrato de arriendo electrónico</Text>
                </li>
                <li className="d-flex justify-content-between mb-2">
                  <span className="fs-xs">Número de tarjeta terminada en:</span>
                  <Text strong>XXXX-XXXX-XXXX-{data.card_detail.card_number}</Text>
                </li>
                <li className="d-flex justify-content-between mb-2">
                  <span className="fs-xs">Monto de la compra:</span>
                  <Text strong>${data.amount}</Text>
                </li>
                <li className="d-flex justify-content-between mb-2">
                  <span className="fs-xs">Orden de compra:</span>
                  <Text strong>{data.buy_order}</Text>
                </li>
                <li className="d-flex justify-content-between mb-2">
                  <span className="fs-xs">Código de autorización:</span>
                  <Text strong>{data.authorization_code}</Text>
                </li>
                <li className="d-flex justify-content-between mb-2">
                  <span className="fs-xs">Nro de cuotas:</span>
                  <Text strong>{installments_number}</Text>
                </li>
                <li className="d-flex justify-content-between mb-2">
                  <span className="fs-xs">Valor cuota:</span>
                  <Text strong>{installments_amount}</Text>
                </li>
                <li className="d-flex justify-content-between mb-2">
                  <span className="fs-xs">Fecha de transacción:</span>
                  <Text strong>{formatString(data.transaction_date, 'es-CL')}</Text>
                </li>
              </ul>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={18} lg={14} className="mx-auto position-relative">
            <Row gutter={36}>
              <Button type="primary" className="mx-auto text-center px-4" size='large' onClick={redirectTo}>
                Continuar
              </Button>
            </Row>
          </Col>
        </Row>
      </Content>
    </React.Fragment >
  );

  return (
    <React.Fragment>
      {activeView === 0 && <PurcharseDetail />}
      {activeView === 1 && <Success />}
      {activeView === 2 && <Fail />}
    </React.Fragment>
  );
};

WebpayConfirmation.propTypes = {
  data: PropTypes.object.isRequired,
  sendMail: PropTypes.func.isRequired,
  sendStats: PropTypes.func.isRequired,
  sourceUrl: PropTypes.string.isRequired,
};

const data = (state) => ({
  persistContractId: state.contract.persistContractId,
  isCreated: state.contract.isCreated,
  data: state.webpay.webpayData,
  sourceUrl: state.contract.sourceUrl
});

const actions = (dispatch) => ({
  sendMail: (email, paymentData) => dispatch({ type: SEND_MAIL, payload: { email, paymentData } }),
  sendStats: (param) => dispatch({ type: SEND_MONITORING, payload: param })
});

export default connect(data, actions)(WebpayConfirmation);